import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/terms/page.tsx")